import React, { useState } from 'react'
import { Input, Grid, Row, Panel, Table } from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { cloneDeep } from 'lodash'
import TooltipButton from '../../components/buttons/TooltipButton'
import { doneLoading, startLoading } from '../../utils/loading'
import {
  deleteProgressOutcome,
  saveSingegleProgressOutcome,
} from '../../redux/actions/projectProgress'
import ConfirmWidget from '../confirm/ConfirmWidget'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'
import notification from '../../utils/notification'
import {
  DELETE_ERR_MSG,
  DELETE_SUCCESS_MSG,
  SAVE_ERR_MSG,
  SAVE_SUCCESS_MSG,
} from '../../constants/msgText'

export default function ProgessOutcomeForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  getValues,
  clearErrors,
  projectId,
  progressId,
  setFormSchema,
  ...props
}) {
  // const [schema, setSchema] = useState(_schema)
  const [datalist, setDataList] = useState(cloneDeep(schema.values || []))
  const [isLoading, setIsLoading] = useState()
  const [deleteObj, setDeleteObj] = useState()
  const [isShowDeleteCF, setIsShowDeleteCF] = useState(false)
  const dataKey = 'datalist'
  const newRowPrefixKey = 'ADD_ID_'
  const { Column, HeaderCell, Cell } = Table

  const handleCallSaveService = async (request, projectId, progressId) => {
    startLoading()
    setIsLoading(true)
    let outcome = null
    try {
      console.log('call saveSingegleProgressOutcome.')
      outcome = await saveSingegleProgressOutcome(projectId, progressId, request)

      notification.open('success', {
        title: SAVE_SUCCESS_MSG,
        duration: 10000,
      })
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        // title: 'Error',
        title:
          e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || SAVE_ERR_MSG,
        duration: 1000000,
        style: { color: 'red' },
      })
    }
    setIsLoading(false)
    doneLoading()

    return outcome
  }

  const handleCallDeleteService = async (id) => {
    startLoading()
    setIsLoading(true)
    let isSuccess = false
    try {
      console.log('call deleteProgressOutcome.')
      isSuccess = await deleteProgressOutcome(id)
      notification.open('success', {
        title: DELETE_SUCCESS_MSG,
        duration: 10000,
      })
    } catch (e) {
      //โชว popup
      console.log('error', e)
      notification.open('error', {
        title:
          e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || DELETE_ERR_MSG,
        duration: 10000,
      })
    }
    setIsLoading(false)
    doneLoading()
    setIsShowDeleteCF(false)
    setDeleteObj()
    return isSuccess
  }

  const isNewRow = (id) => {
    return id.startsWith(newRowPrefixKey)
  }

  const onAddNewRow = (rowData) => {
    let arr = [...datalist]
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]
      if (element.id == rowData.id) {
        let date = new Date().getTime()
        console.log('add id ', date.toString())
        let data = {
          id: `${newRowPrefixKey}${date}`,
          projectObjectiveId: element.id,
          expectedOutcome: '',
          actualOutcome: '',
          enableDelete: true,
          enableSave: true,
          isDelete: false,
        }
        arr[index].children.push(data)
        break
      }
    }

    console.log('after add ', arr)
    setDataList(arr)
    setValue(dataKey, arr)
  }

  const onChangeValue = (rowData, value, key) => {
    let arr = [...datalist]
    for (let labelIndex = 0; labelIndex < arr.length; labelIndex++) {
      const element = arr[labelIndex]

      if (element.id == rowData._parent.id) {
        for (let subIndex = 0; subIndex < element.children.length; subIndex++) {
          const subElement = element.children[subIndex]
          if (subElement.id == rowData.id) {
            arr[labelIndex].children[subIndex][key] = value

            setDataList(arr)
            setValue(dataKey, arr)
            break
          }
        }
        break
      }
    }
  }

  const onDeleteRow = async (rowData) => {
    let arr = [...datalist]
    for (let labelIndex = 0; labelIndex < arr.length; labelIndex++) {
      const element = arr[labelIndex]

      if (element.id == rowData._parent.id) {
        for (let subIndex = 0; subIndex < element.children.length; subIndex++) {
          const subElement = element.children[subIndex]
          if (subElement.id == rowData.id) {
            if (!isNewRow(rowData.id)) {
              var result = await handleCallDeleteService(rowData.id)

              if (result) {
                arr[labelIndex].children.splice(subIndex, 1)
              }
            } else {
              arr[labelIndex].children.splice(subIndex, 1)
            }

            setDataList(arr)
            setValue(dataKey, arr)
            break
          }
        }
        break
      }
    }
    schema.values = arr
    setFormSchema(schema)
  }

  const onSaveRow = async (rowData) => {
    let arr = [...datalist]
    for (let labelIndex = 0; labelIndex < arr.length; labelIndex++) {
      const element = arr[labelIndex]

      if (element.id == rowData._parent.id) {
        for (let subIndex = 0; subIndex < element.children.length; subIndex++) {
          const subElement = element.children[subIndex]
          if (subElement.id == rowData.id) {
            let request = {
              id: isNewRow(subElement.id) ? '' : subElement.id,
              projectObjectiveId: subElement.projectObjectiveId,
              expectedOutcome: subElement.expectedOutcome,
              actualOutcome: subElement.actualOutcome,
            }

            var respData = await handleCallSaveService(request, projectId, progressId)

            if (respData) {
              console.log('respData.id : ', respData.id)
              arr[labelIndex].children[subIndex].id = respData.id
              arr[labelIndex].children[subIndex].projectObjectiveId = respData.projectObjectiveId
              arr[labelIndex].children[subIndex].expectedOutcome = respData.expectedOutcome
              arr[labelIndex].children[subIndex].actualOutcome = respData.actualOutcome
              arr[labelIndex].children[subIndex].enableDelete = respData.enableDelete
              arr[labelIndex].children[subIndex].enableSave = respData.enableSave
              arr[labelIndex].children[subIndex].isDelete = respData.isDelete
            }

            break
          }
        }
        break
      }
    }

    setDataList(arr)
    setValue(dataKey, arr)

    schema.values = arr
    setFormSchema(schema)
  }

  return (
    <div>
      <Row>
        <Panel bodyFill>
          <Grid fluid>
            <Controller
              key={dataKey}
              name={dataKey}
              control={control}
              defaultValue={datalist || []}
              render={(props) => {
                return (
                  // />
                  <Table
                    isTree
                    defaultExpandAllRows
                    rowKey="id"
                    cellBordered
                    // height={400}
                    autoHeight
                    wordWrap
                    data={props.value || []}
                  >
                    <Column resizable width={500}>
                      <HeaderCell>{schema.columnText1}</HeaderCell>
                      <Cell>
                        {(rowData) => {
                          if (rowData.label) {
                            return rowData.label
                          } else {
                            return rowData.enableDelete ? (
                              <>
                                {errors[`${schema.expectedOutcome.name}_${rowData.id}`] && (
                                  <Row style={{ marginBottom: 10 }}>
                                    <ErrorMessage
                                      error={errors[`${schema.expectedOutcome.name}_${rowData.id}`]}
                                    />
                                  </Row>
                                )}
                                <Input
                                  key={`${schema.expectedOutcome.name}_${rowData.id}`}
                                  name={`${schema.expectedOutcome.name}_${rowData.id}`}
                                  placeholder={schema.expectedOutcome.hint}
                                  defaultValue={rowData.expectedOutcome}
                                  // inputRef={register(
                                  //   isValidators(schema.expectedOutcome.validators)
                                  // )}
                                  rows={3}
                                  componentClass="textarea"
                                  onChange={(value) => {
                                    onChangeValue(rowData, value, 'expectedOutcome')
                                  }}
                                />
                              </>
                            ) : (
                              rowData.expectedOutcome
                            )
                          }
                        }}
                      </Cell>
                    </Column>

                    <Column minWidth={350} flexGrow={1}>
                      <HeaderCell>{schema.columnText2}</HeaderCell>
                      <Cell>
                        {(rowData) => {
                          return rowData.projectObjectiveId ? (
                            <>
                              {errors[`${schema.actualOutcome.name}_${rowData.id}`] && (
                                <Row style={{ marginBottom: 10 }}>
                                  <ErrorMessage
                                    error={errors[`${schema.actualOutcome.name}_${rowData.id}`]}
                                  />
                                </Row>
                              )}
                              <div style={{ minHeight: 240, minWidth: 340 }}>
                                <CKEditorFrom
                                  name={`${schema.actualOutcome.name}_${rowData.id}`}
                                  value={rowData.actualOutcome}
                                  schema={schema.actualOutcome}
                                  register={register}
                                  Controller={Controller}
                                  control={control}
                                  errors={errors}
                                  setValue={setValue}
                                  clearErrors={clearErrors}
                                  onChange={(value) => {
                                    onChangeValue(rowData, value, 'actualOutcome')
                                  }}
                                  // toolbar={[['Maximize']]}
                                  toolbar={[[]]}
                                />
                              </div>
                              {/* <Input
                                key={`${schema.actualOutcome.name}_${rowData.id}`}
                                name={`${schema.actualOutcome.name}_${rowData.id}`}
                                placeholder={schema.actualOutcome.hint}
                                defaultValue={rowData.actualOutcome}
                                //inputRef={register(isValidators(schema.actualOutcome.validators))}
                                rows={3}
                                componentClass="textarea"
                                onChange={(value) => {
                                  onChangeValue(rowData, value, 'actualOutcome')
                                }}
                              /> */}
                            </>
                          ) : (
                            rowData.actualOutcome
                          )
                        }}
                      </Cell>
                    </Column>
                    <Column width={110} align="center" fixed="right">
                      <HeaderCell></HeaderCell>
                      <Cell>
                        {(rowData) => {
                          if (rowData.addLevel) {
                            return (
                              <TooltipButton
                                style={{ width: '100%' }}
                                icon="plus"
                                tooltip={`เพิ่ม${schema.buttonText || ''}`}
                                onClick={() => onAddNewRow(rowData)}
                                disabled={isLoading}
                              >
                                เพิ่ม
                              </TooltipButton>
                            )
                          } else {
                            return (
                              <>
                                {rowData.enableSave && (
                                  <TooltipButton
                                    style={{ width: '100%' }}
                                    icon="save"
                                    tooltip={`บันทึก${schema.buttonText || ''}`}
                                    onClick={() => onSaveRow(rowData)}
                                    disabled={isLoading}
                                  >
                                    บันทึก
                                  </TooltipButton>
                                )}

                                {rowData.enableDelete && (
                                  <TooltipButton
                                    style={{ width: '100%', marginTop: 10 }}
                                    icon="trash"
                                    tooltip={`ลบ${schema.buttonText || ''}`}
                                    onClick={() => {
                                      if (isNewRow(rowData.id)) {
                                        onDeleteRow(rowData)
                                      } else {
                                        setDeleteObj(rowData)
                                        setIsShowDeleteCF(true)
                                      }
                                    }}
                                    disabled={isLoading}
                                  >
                                    ลบ
                                  </TooltipButton>
                                )}
                              </>
                            )
                          }
                        }}
                      </Cell>
                    </Column>
                  </Table>
                )
              }}
            />
          </Grid>
        </Panel>

        <ConfirmWidget
          title={`ยืนยันการลบ`}
          show={isShowDeleteCF}
          size="sm"
          detail={
            <>
              {`ยืนยันการลบผลลัพธ์ : `}
              <b>{deleteObj?.expectedOutcome || ''}</b>
            </>
          }
          onCancle={() => {
            setIsShowDeleteCF(false)
            setDeleteObj()
          }}
          onConfirm={() => onDeleteRow(deleteObj)}
        />
      </Row>
    </div>
  )
}
